// 토스트/모달/인증 글로벌 상태 — 프로토타입의 showToast/openModal + 로그아웃 공유
import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'warn' | 'info';
export interface Toast {
  id: string;
  type: ToastType;
  msg: string;
}

export interface ModalState {
  open: boolean;
  title: string;
  sub: string;
  body: string;
  bodyPlain?: boolean; // true면 reason-box 없이 plain 렌더링
  confirmLabel: string;
  onConfirm?: () => void;
}

interface UIState {
  toasts: Toast[];
  showToast: (msg: string, type?: ToastType) => string;
  dismissToast: (id: string) => void;
  modal: ModalState;
  openModal: (m: Omit<ModalState, 'open'>) => void;
  closeModal: () => void;
  // 인증 공유 상태 — LoginGate와 App 간 logout 동기화
  authVersion: number;
  bumpAuthVersion: () => void;
}

const TOAST_TTL_MS = 3000;
let seq = 0;

export const useUI = create<UIState>((set, get) => ({
  toasts: [],
  showToast: (msg, type = 'info') => {
    const id = `t_${++seq}`;
    set((s) => ({ toasts: [...s.toasts, { id, msg, type }] }));
    setTimeout(() => get().dismissToast(id), TOAST_TTL_MS);
    return id;
  },
  dismissToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  modal: { open: false, title: '', sub: '', body: '', confirmLabel: '확인' },
  openModal: (m) => set({ modal: { ...m, open: true } }),
  closeModal: () => set((s) => ({ modal: { ...s.modal, open: false } })),
  authVersion: 0,
  bumpAuthVersion: () => set((s) => ({ authVersion: s.authVersion + 1 })),
}));
